import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import StarBackground from "../components/StarBackground";
import configSyllables from "../exercises/syllables/syllablesConfig";
import configNonWords from "../exercises/nonWords/nonWordsConfig";
import configSentence from "../exercises/sentences/sentencesConfig";


export default function Congratulations() {
    const navigate = useNavigate();
    const { exerciseId } = useParams();
    
    const messages = {
        syllables: {
            title: 'Hai completato l\'esercizio sulle Sillabe! 🎉',
            color: configSyllables.headerColor
        },
        nonWords: {
            title: 'Hai completato l\'esercizio sulle Non Parole! 🎊',
            color: configNonWords.headerColor
        },
        sentences: {
            title: 'Hai completato l\'esercizio sulle Frasi! 🥳',
            color: configSentence.headerColor
        }
    };
    
    const handleBackToMenu = () => {
        navigate('/pages/exePage');
    };
    
    const current = messages[exerciseId] || {
        title: 'Esercizio completato!',
        color: '#888'
    };
    
    return (
        <>
            <Header color={current.color} />
            <div style={styles.wrapper}>
                <StarBackground />
                <h1 style={{ ...styles.title, color: current.color }}>{current.title}</h1>
                <button onClick={handleBackToMenu} style={{ ...styles.button, backgroundColor: current.color }}>
                    Torna al Menu
                </button>
            </div>
        </>
    );
}

const styles = {
    wrapper: {
        height: '100vh',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Autour One', cursive",
        textAlign: 'center',
        padding: '20px',
        gap: '30px'
    },
    title: {
        fontSize: '32px',
        maxWidth: '80vw'
    },
    button: {
        color: 'white',
        padding: '12px 24px',
        borderRadius: '12px',
        border: 'none',
        fontSize: '20px',
        fontWeight: 'bold',
        cursor: 'pointer',
        fontFamily: "'Autour One', cursive"
    }
};
